import { Link } from '../Link';
import styles from './LinkCloud.module.scss';

export interface LinkCloudItemProps {
  href: string;
  title: string;
  label: string;
  ariaLabel?: string;
  target?: string;
  rel?: string;
}

interface LinkCloudProps {
  links: LinkCloudItemProps[];
  testId: string;
  /** Pass `false` to opt out of Next prefetching — for SEO link clouds that rarely get clicked. */
  prefetch?: boolean | null;
}

export const LinkCloud: React.FC<LinkCloudProps> = ({ links, testId, prefetch }) => (
  <ul className={styles.list} data-testid={testId}>
    {links.map((link, index) => (
      <li key={`link-cloud-${index}`} className={styles.item}>
        <Link
          href={link.href}
          title={link.title}
          ariaLabel={link.ariaLabel}
          target={link.target}
          rel={link.rel}
          prefetch={prefetch}
          className={styles.link}
          data-testid={`${testId}-link-${index + 1}`}
        >
          {link.label}
        </Link>
      </li>
    ))}
  </ul>
);
